module.exports = __webpack_public_path__ + "img/Company_Rank_chart_icon.7dad29c7.png";